import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1d066f3e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "dialog"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "dialog__title"
  }, " 项目类型 ", -1);
});

var _hoisted_3 = {
  class: "dialog_text"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "dialog__title"
  }, " 开发周期 ", -1);
});

var _hoisted_5 = {
  class: "dialog_text"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "dialog__title"
  }, " 开发软件 ", -1);
});

var _hoisted_7 = {
  class: "dialog_text"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "dialog__title"
  }, " 开发背景 ", -1);
});

var _hoisted_9 = {
  class: "dialog_text"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "dialog__title"
  }, " 项目职责 ", -1);
});

var _hoisted_11 = ["innerHTML"];

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "dialog__title"
  }, " 项目预览 ", -1);
});

var _hoisted_13 = {
  key: 0,
  class: "dialog__image_box"
};
var _hoisted_14 = {
  key: 1,
  class: "dialog_text"
};
var _hoisted_15 = {
  class: "experience_buttom"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  var _component_vue_easy_lightbox = _resolveComponent("vue-easy-lightbox");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.showDialog = $event;
    }),
    draggable: "",
    "destroy-on-close": "",
    title: $props.content.project_title,
    center: "",
    onClose: $setup.closed
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
        class: "buttomDiv buttonFlex hvr-back-pulse",
        onClick: _cache[0] || (_cache[0] = function () {
          return $setup.handleClose && $setup.handleClose.apply($setup, arguments);
        })
      }, "我看完啦")])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, _toDisplayString($props.content.project_style || '我不到啊'), 1), _hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString($props.content.project_time || '我不到啊'), 1), _hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString($props.content.project_software || 'Vue'), 1), _hoisted_8, _createElementVNode("div", _hoisted_9, _toDisplayString($props.content.project_Introduction || '没有背景'), 1), _hoisted_10, _createElementVNode("div", {
        class: "dialog__introduce",
        innerHTML: $props.content.project_duty
      }, null, 8, _hoisted_11), _hoisted_12, $props.content.project_image !== '' && $props.content.project_image !== [] && $props.content.project_image ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.content.project_image, function (item, index) {
        return _openBlock(), _createBlock(_component_el_image, {
          key: index,
          lazy: "",
          class: "dialog__image",
          src: item.src,
          onClick: function onClick($event) {
            return $setup.openLightbox(index);
          }
        }, null, 8, ["src", "onClick"]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_14, " 机密项目不可以看哦 ")), _createVNode(_component_vue_easy_lightbox, {
        "esc-disabled": "",
        "move-disabled": "",
        visible: _ctx.visible,
        imgs: _ctx.imgs,
        index: _ctx.index,
        onHide: $setup.handleHide
      }, null, 8, ["visible", "imgs", "index", "onHide"])])];
    }),
    _: 1
  }, 8, ["modelValue", "title", "onClose"]);
}